import { apiRequest } from "./apiWrapper"

export const superSearchApi = async (path, query) => {
  const userId = JSON.parse(localStorage.getItem('user'))?.user_id
  try {
    const response = await apiRequest({
      method: 'get',
      url: `${path}query=${encodeURIComponent(query)}`,
      headers: { 'x-user-id': userId }
    })
    return response
  } catch (error) {
    console.error('API fetch error:', error)
    throw error
  }
}
